export default __webpack_public_path__ + "assets/profeature-card-fixed-small.09055c5f4ec23a7ac709b4edcd1fc805.jpg";